/**
 * Condition-form schema types shared between the CCS Pharmacy mobile app
 * and the admin panels (Chain Admin / Pharmacy Admin). Moved out of the
 * mobile app's `types/consultation.ts` (Task #564) so both surfaces use one
 * source of truth for form field ids -> human-readable labels.
 *
 * `CCSCondition` here is intentionally duplicated (not imported) by the
 * mobile app's `ConditionInfo`/`CONDITIONS`, which layer on
 * `@expo/vector-icons` metadata this package must stay free of.
 */

export type CCSCondition =
  | "conjunctivitis_infective"
  | "rhinitis_allergic"
  | "impetigo"
  | "oral_thrush"
  | "shingles"
  | "vv_thrush"
  | "cold_sores"
  | "uti";

export const CCS_CONDITIONS: CCSCondition[] = [
  "conjunctivitis_infective",
  "rhinitis_allergic",
  "impetigo",
  "oral_thrush",
  "shingles",
  "vv_thrush",
  "cold_sores",
  "uti",
];

export type FormFieldType =
  | "text"
  | "textarea"
  | "radio"
  | "select"
  | "dropdown"
  | "number"
  | "date"
  | "ppsn"
  | "eircode"
  | "checkbox"
  | "bullets"
  | "signature"
  | "image";

export interface FormField {
  id: string;
  label: string;
  type: FormFieldType;
  value?: string;
  required?: boolean;
  options?: string[];
  placeholder?: string;
  hint?: string;
  yesNote?: string;
  valueNotes?: Record<string, { message: string; type: "info" | "warning" | "danger" }>;
  computed?: boolean;
  hidden?: boolean;
  showIf?: { fieldId: string; value: string | string[] };
  displaySuffix?: string;
}

export interface FormSection {
  id: string;
  title: string;
  description?: string;
  fields: FormField[];
}
